/* eslint-disable react/forbid-prop-types */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import CurrencyCard from '../../../Accounts/partials/CurrencyCard';

const Currencies = ({
  wallets,
  mainScreen,
  openScreen,
  updateForm,
  form,
  currencies,
  isOpenSourceCurrencies,
}) => {
  const { t: translate } = useTranslation();

  const [searchValue, setSearchValue] = useState('');

  const [renderedCurrencies, setRenderedCurrencies] = useState(currencies);

  const handleSearchInput = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (searchValue) {
      const filterWallets = Object.values(currencies).filter(
        (c) =>
          c.currency_code.toLowerCase().includes(searchValue.toLowerCase()) ||
          c.currency_name?.toUpperCase().search(searchValue.toUpperCase()) >= 0
      );

      setRenderedCurrencies(filterWallets);
    } else {
      setRenderedCurrencies(currencies);
    }
  }, [searchValue, currencies]);

  const chooseWallet = (data) => {
    if (isOpenSourceCurrencies) {
      const _sourceWallet = wallets.find((w) => w.coin === data.currency_code);

      updateForm({ ...form, source: data, sourceWallet: _sourceWallet });
    } else {
      const _destinationWallet = wallets.find((w) => w.coin === data.currency_code);

      updateForm({ ...form, destination: data, destinationWallet: _destinationWallet });
    }
  };

  return (
    <ModalBodyLayout
      title={
        isOpenSourceCurrencies
          ? translate('select_source_currency_title')
          : translate('select_destination_currency_title')
      }
      onPrevClick={() => openScreen(mainScreen)}
      isScrollable
      withBack>
      <div className="my-3 ">
        <div className="rounded bg-light p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative">
          <input
            type="text"
            value={searchValue}
            onChange={(e) => handleSearchInput(e)}
            className="form-control border-1 border-transparent bg-light shadow-none w-100 ps-5 d-flex"
            placeholder={translate('select_account_input_placeholder')}
          />
          <i className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
          <i
            onClick={() => {
              setSearchValue('');
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
            label="close"
            hidden={searchValue === '' || searchValue === null || searchValue === undefined}
            className="icon icon-close-other text-white position-absolute top-50 end-0 translate-middle-y pe-3"
          />
        </div>
        {Object.values(renderedCurrencies)
          .filter(
            (item) =>
              // BXX is hidden hardcoded due to the requirement DV-3093
              item.currency_code !== 'bxx' &&
              ((isOpenSourceCurrencies && item.currency_code !== form.destination.currency_code) ||
                (!isOpenSourceCurrencies && item.currency_code !== form.source.currency_code))
          )
          .map((item) => (
            <CurrencyCard
              wallets={wallets}
              key={item.id}
              data={item}
              openScreen={openScreen}
              chooseWallet={chooseWallet}
              mainScreen={mainScreen}
            />
          ))}
      </div>
    </ModalBodyLayout>
  );
};

export default Currencies;

Currencies.propTypes = {
  wallets: PropTypes.array.isRequired,
  openScreen: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  mainScreen: PropTypes.string.isRequired,
  currencies: PropTypes.array.isRequired,
  isOpenSourceCurrencies: PropTypes.bool.isRequired,
};
